import { connect } from 'react-redux';
import _get from 'lodash-es/get';
import {
  openErrorToast,
  openSuccessToast,
} from '../../../../reducers/uiLogic/index';
import { getAllGroupsInitiate } from '../../../../actions/groups';
import {
  getProgramInfoInitiate,
  createProgramInitiate,
  clearProgramInfo,
} from '../../../../actions/programs';
import ReviewPlan from './ReviewPlan';

const mapStateToProps = state => {
  const programInfo = _get(state, 'programs.programInfo', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const companyId = _get(state, 'user.selectedWorkspace.company_id', '');
  const currentFlow = _get(state, 'user.currentFlow', 0);
  const groupsData = _get(state, 'groups', {});

  return {
    companyId,
    currentFlow,
    selectedWorkspace,
    groupsData,
    programInfo,
    createProgramSuccess: _get(state, 'apiState.CREATE_PROGRAM.success', false),
    creatingProgram:
      _get(state, 'apiState.CREATE_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.CREATE_PROGRAM.isIdle', true),
    fetchingProgramInfo:
      _get(state, 'apiState.GET_PROGRAM_INFO.isFetching', false) &&
      !_get(state, 'apiState.GET_PROGRAM_INFO.isIdle', true),
    fetchedProgramInfo: _get(state, 'apiState.GET_PROGRAM_INFO.success', false),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  showSuccessToast: message => dispatch(openSuccessToast(message)),
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  getProgramInfo: payload => dispatch(getProgramInfoInitiate(payload)),
  createProgram: payload => dispatch(createProgramInitiate(payload)),
  clearProgramInfo: () => dispatch(clearProgramInfo()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewPlan);
